import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
import {arrayFilter_OnlyUnique, getApiProps, updateObjectByDiff} from "@/lib/lib";

const changedField = 'changed__time';

export default {
    state: {
        parkings_index: [],
        parkings: [],
        parkings_last_hour: [],
    },
    actions: {
        fetchParkings4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getParkingsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchParkings4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastParkings', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchParkingsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('parkings', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.parkings.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeParkings', response.data)
                            commit('setParkingsIndex', {...args, count: response.data.length})
                            if (args.unitId && isToday) {
                                //dispatch('fetchParkingsLastTime', args)
                            }
                            if (!args.unitId && response.data.length) {
                                response.data
                                    .map(e => e.unit_id)
                                    .filter(arrayFilter_OnlyUnique)
                                    .forEach(unitId => {
                                        commit('setParkingsIndex', {...args, unitId, count: 1})
                                    })
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchParkings4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastParkings', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchParkingsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchParkings4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getParkingsIndex.find(i => (i.unitId == args.unitId && ???))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchParkings4Date', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchParkings4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastParkings', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchParkingsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('parkings', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;delete params.force;
                this.$api.parkings.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeParkings', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchParkings4Date', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchParkings4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastParkings', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchParkingsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchParkingsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastParkings', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchParkingsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            // delete args.date
            args.force = true
            return dispatch('fetchParkings4Date', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastParkings', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchParkingsChanged', args, inprogress: false})
                });
        },

        fetchParkingsLastTime({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }
                let lmsg_time = getters.getUnitsLmsgsByIds[args.unitId]?.time || 0
                if (!(lmsg_time > getters.getTimeToday)) {
                    return resolve(true)
                }
                let today = getters.getDateToday
                //Index today
                let indx_today = getters.getParkingsIndex.find(i => i.date == today && i.unitId == args.unitId)
                if (!indx_today) {
                    return resolve(true)
                }
                //trips&parkings time_end
                let time_ends = [
                    getters.getTripsMaxTimeEndByUnitsIds[args.unitId],
                    getters.getParkingsMaxTimeEndByUnitsIds[args.unitId]
                ].filter(t => !!t && t > 0)
                if (!time_ends.length) time_ends = [getters.getTimeToday]
                let time_start = Math.max(...time_ends)

                if (time_start > lmsg_time) {
                    console.warn('fetchParkingsLastTime: Lmsg.time', {args, lmsg_time, time_start})
                    return resolve(true)
                }

                dispatch('setLastCall', {name: 'fetchParkingsLastTime', args, time: Date.now() / 1000})

                let params = getApiProps('parkings', {withAddress: 1, ...args, date: '', 'start-time': time_start})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.parkings.getLast(args.unitId, '', params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeParkingsLastHour', {unitId: args.unitId, time_start, data: response.data})
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchParkingsLastTime', args, inprogress: false})
                    });
            })
        },

        reloadParkings({commit, dispatch}, args) {
            commit('clearParkings')
            return dispatch('fetchParkings4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setParkingsIndex(state, params) {
            let i = state.parkings_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.parkings_index.push(Object.freeze({...params}))
            } else {
                state.parkings_index[i] = Object.freeze({...state.parkings_index[i], ...params})
            }
        },
        storeParkings(state, nParkings) {
            const exactKeys = new Set(state.parkings.map(p => `${p.unit_id}|${p.time_start?.utc}|${p.time_end?.utc}`))
            nParkings = nParkings
                .filter(p => !exactKeys.has(`${p.unit_id}|${p.time_start?.utc}|${p.time_end?.utc}`))
                //.map(p => Object.freeze(p))

            // if(nParkings.length) state.parkings.push(...nParkings)
            if (!nParkings.length) return false
            if (!state.parkings.length) {
                state.parkings = nParkings
                return true
            }
            const indexByIdentity = new Map(state.parkings.map((st, i) => [`${st.unit_id}|${st.time_start?.utc}`, i]))
            nParkings.forEach(function (nParking) {
                const identityKey = `${nParking.unit_id}|${nParking.time_start?.utc}`
                let i = indexByIdentity.has(identityKey) ? indexByIdentity.get(identityKey) : -1
                if (i < 0) {
                    indexByIdentity.set(identityKey, state.parkings.length)
                    state.parkings.push(Object.freeze(nParking))
                } else
                if (state.parkings[i][changedField] != nParking[changedField])
                {
                    // updateObjectByDiff(state.parkings[i], nParking)
                    delete nParking.unit_id;delete nParking.time_start;
                    state.parkings[i] = Object.freeze({...state.parkings[i], ...nParking})
                }
            })
        },

        storeParkingsLastHour(state, args) {
            state.parkings_last_hour = state.parkings_last_hour.filter(st => {
                return st.unit_id != args.unitId || st.time_start?.utc >= args.time_start
            })

            let nParkings = args.data
            nParkings = nParkings
                .filter(st => {
                    return st.time_end?.utc > args.time_start
                })
                .filter(t => !state.parkings_last_hour.find(sp => {
                    return sp.unit_id == t.unit_id
                        && sp.time_start?.utc == t.time_start?.utc
                        && sp.time_end?.utc == t.time_end?.utc
                }))
                //.map(t => Object.freeze(t))

            // if(nParkings.length) state.parkings_last_hour.push(...nParkings)
            if (!nParkings.length) return false
            if (!state.parkings_last_hour.length) {
                state.parkings_last_hour = nParkings
                return true
            }
            nParkings.forEach(function (nParking) {
                let i = state.parkings_last_hour.findIndex(st => {
                    return st.unit_id == nParking.unit_id
                        && st.time_start?.utc == nParking.time_start?.utc
                        // && st.time_end?.utc == nParking.time_end?.utc
                })
                if (i < 0) {
                    state.parkings_last_hour.push(nParking) //(Object.freeze(nParking))
                } else
                {
                    updateObjectByDiff(state.parkings_last_hour[i], nParking)
                    // nParking = {...state.parkings_last_hour[i], ...nParking}
                    // state.parkings_last_hour[i] = nParking //Object.freeze(nParking)
                }
            })
        },

        clearParkings(state, {unitId} = {}) {
            if (unitId) {
                state.parkings_last_hour = state.parkings_last_hour.filter(p => (p.unit_id || p.object_id) != unitId)
                state.parkings = state.parkings.filter(p => (p.unit_id || p.object_id) != unitId)
                state.parkings_index = state.parkings_index.filter(i => i.unitId != unitId)
            } else {
                state.parkings_last_hour = [];
                state.parkings = [];
                state.parkings_index = [];
            }
        },
    },
    getters: {
        getParkingsIndex(state) {
            return state.parkings_index
        },
        getParkings(state) {
            return [...state.parkings, ...state.parkings_last_hour]
        },
        getParkingsMaxTimeEndByUnitsIds(state) {
            return state.parkings.reduce((MaxTimeEndByUnitsIds, parking) => {
                if (+(parking?.time_end?.utc || 0) > +(MaxTimeEndByUnitsIds[parking.unit_id] || 0)) {
                    MaxTimeEndByUnitsIds[parking.unit_id] = parking?.time_end?.utc
                }
                return MaxTimeEndByUnitsIds
            }, {})
        },
    }
}
